import React from 'react';
import { Box } from '@mui/material';

const SectionDivider = ({ from = '#FFFFFF', to = '#F7F9FC' }) => (
  <Box
    component="svg"
    viewBox="0 0 1440 48"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="none"
    sx={{
      display: 'block',
      width: '100%',
      height: { xs: '24px', md: '48px' },
      backgroundColor: from,
    }}
  >
    <path
      d="M0 0L48 4C96 8 192 16 288 21.3C384 27 480 29 576 28C672 27 768 21 864 18.7C960 16 1056 19 1152 22.7C1248 27 1344 31 1392 33L1440 35V48H1392C1344 48 1248 48 1152 48C1056 48 960 48 864 48C768 48 672 48 576 48C480 48 384 48 288 48C192 48 96 48 48 48H0V0Z"
      fill={to}
    />
  </Box>
);

export default SectionDivider;
